module.exports = __webpack_public_path__ + "img/logo_256.58ad66ba.png";